export enum DeviceType {
    LIB = "battery",
    EV = "yanekara-battery",
    PCS = "pcs",
    EQ = "eq",
    PM = "powermeter",
    SM = "SM",
    MM = "meteorometer",
    EDGE = "edge",
//  EPM = "ecopowermeter",
}

export enum FailureStatus {
    NORMAL = "NORMAL",
    WARNING = "WARNING",
    ABNORMAL = "ABNORMAL",
    INFORMATION = "INFORMATION",
}

export enum SummaryType {
    DAY = "5min",
    MONTH = "day",
    YEAR = "month",
}

// export enum SignalName {
//     battery_instant_power = "battery_instant_power",
//     battery_expected_energy_remaining = "battery_expected_energy_remaining",
//     battery_nominal_full_pack_energy = "battery_nominal_full_pack_energy",
//     battery_max_charge_power = "battery_max_charge_power",
//     battery_max_discharge_power = "battery_max_discharge_power",
//     site_instant_power = "site_instant_power",
//     battery_target_power = "battery_target_power",
//     min_battery_expected_energy_remaining = "min_battery_expected_energy_remaining",
//     pcs_sma_system_interconnection = "pcs_sma_system_interconnection",
//     pcs_sma_rated_power = "pcs_sma_rated_power",
//     pcs_sma_tatal_energy = "pcs_sma_tatal_energy",
//     pcs_sma_real_power = "pcs_sma_real_power",
//     pcs_sma_output_limit = "pcs_sma_output_limit",
//     meter_instant_power_1 = "meter_instant_power_1",
//     meter_instant_power_2 = "meter_instant_power_2",
//     meter_energy_integration_1 = "meter_energy_integration_1",
//     meter_energy_integration_2 = "meter_energy_integration_2",
//     meter_real_power_1 = "meter_real_power_1",
//     meter_real_power_2 = "meter_real_power_2",
//     meter_rec_energy_integration = "meter_rec_energy_integration",
//     meter_trns_energy_integration = "meter_trns_energy_integration",
//     mm_irradiance = "mm_irradiance",
//     mm_cell_temperature = "mm_cell_temperature",
//     mm_ambient_temperature = "mm_ambient_temperature",
//     battery_power_system_interconnection_status = "battery_power_system_interconnection_status",
//     battery_charging_capacity = "battery_charging_capacity",
//     battery_discharging_capacity = "battery_discharging_capacity",
//     battery_chargeable_energy = "battery_chargeable_energy",
//     battery_dischargeable_energy = "battery_dischargeable_energy",
//     battery_actual_operation_mode = "battery_actual_operation_mode",
//     battery_cumulative_charging_energy = "battery_cumulative_charging_energy",
//     battery_cumulative_discharging_energy = "battery_cumulative_discharging_energy",
//     battery_operation_mode = "battery_operation_mode",
//     battery_expected_energy_remaining_percent = "battery_expected_energy_remaining_percent",
//     battery_effective_charging_capacity = "battery_effective_charging_capacity",
//     battery_effective_discharging_capacity = "battery_effective_discharging_capacity",
//     battery_minmax_charging_power = "battery_minmax_charging_power",
//     battery_minmax_discharging_power = "battery_minmax_discharging_power",
//     eq_water_heating_on = "eq_water_heating_on",
//     eq_water_heating_status = "eq_water_heating_status",
//     eq_target_water_heating_volume = "eq_target_water_heating_volume",
//     eq_tank_water_temperature = "eq_tank_water_temperature",
//     eq_alarm_status = "eq_alarm_status",
//     eq_target_supplied_water_temperature = "eq_target_supplied_water_temperature",
//     eq_target_bath_water_temperature = "eq_target_bath_water_temperature",
//     eq_remaining_water_volume = "eq_remaining_water_volume",
//     eq_winter_rated_power = "eq_winter_rated_power",
//     eq_between_season_rated_power = "eq_between_season_rated_power",
//     eq_summer_rated_power = "eq_summer_rated_power",
//     eq_remaining_water = "eq_remaining_water",
//     eq_target_capacity = "eq_target_capacity",
//     eq_bath_water_volume_3 = "eq_bath_water_volume_3",
//     am_IoTplatform_software_error = "am_IoTplatform_software_error",
//     am_IoTplatform_db_error = "am_IoTplatform_db_error",
//     am_IoTplatform2edgeerror = "am_IoTplatform2edgeerror",
//     am_edge_software_error = "am_edge_software_error",
//     am_edge2device_error = "am_edge2device_error",
//     pcs_heavy_error = "pcs_heavy_error",
//     pcs_light_error = "pcs_light_error",
// }

// export enum SignalErrName { 
//     meter_unit1_com_error = "meter_unit1_com_error",
//     meter_unit2_com_error = "meter_unit2_com_error",
//     meter_unit3_com_error = "meter_unit3_com_error",
//     meter_unit4_com_error = "meter_unit4_com_error",
//     meter_unit5_com_error = "meter_unit5_com_error",
//     meter_unit6_com_error = "meter_unit6_com_error",
//     meter_unit7_com_error = "meter_unit7_com_error",
//     meter_unit8_com_error = "meter_unit8_com_error",
//     meter_sd_error = "meter_sd_error",
//     meter_battery_error = "meter_battery_error",
//     meter_software_error = "meter_software_error",
//     meter_factory_error = "meter_factory_error",
//     meter_user_setting_error = "meter_user_setting_error",
//     meter_power_info_error = "meter_power_info_error",
//     meter_demand_info_error = "meter_demand_info_error",
//     meter_min_max_info_error = "meter_min_max_info_error",
//     battery_enl_error = "battery_enl_error",
//     battery_enl_maker_error = "battery_enl_maker_error",
//     battery_site_meter_com_error = "battery_site_meter_com_error",
//     battery_meter_com_error = "battery_meter_com_error",
//     battery_load_meter_com_error = "battery_load_meter_com_error",
//     battery_solar_meter_com_error = "battery_solar_meter_com_error",
//     battery_busway_meter_com_error = "battery_busway_meter_com_error",
//     battery_generator_meter_com_error = "battery_generator_meter_com_error",
//     battery_comms_error = "battery_comms_error",
//     battery_fault_error = "battery_fault_error",
//     battery_unexpected_real_power_error = "battery_unexpected_real_power_error",
//     battery_unexpected_reactive_power_error = "battery_unexpected_reactive_power_error",
//     battery_latency_error = "battery_latency_error",
//     battery_smart_inverter_active_error = "battery_smart_inverter_active_error",
//     eq_enl_error = "eq_enl_error",
//     eq_enl_maker_error = "eq_enl_maker_error",
// }

// export type Site = {
//     id?: string | null,
//     name?: string | null,
//     owner?: string | null,
//     lat?: string | null,
//     lon?: string | null,
//     failure_status?: FailureStatus | null,
//     power?: number | null,
//     demand?: number | null,
//     soc?: number | null,
//     solor?: number | null,
//     temperture?: number | null,
//     devices?: [Device] | null,
// };

// export type Device = {
//     id?: string | null,
//     type?: DeviceType | null,
//     name?: string | null,
//     manufacturer?: string | null,
//     model_number?: string | null,
//     battery_nominal_full_pack_energy?: number | null,
//     battery_min_charge_power?: number | null,
//     battery_max_charge_power?: number | null,
//     battery_min_discharge_power?: number | null,
//     battery_max_discharge_power?: number | null,
//     battery_min_energy_remaining?: number | null,
//     battery_charge_discharge_efficiency?: number | null,
//     eq_tank_capcity?: number | null,
//     eq_heat_loss_efficiency?: number | null,
//     eq_min_hotwater_remaining?: number | null,
//     signal_names?: Array< SignalName | null > | null,
//     deviceSiteId?: string | null,
//     failure_status?: FailureStatus | null,
// };

// export type Alert = {
//     id?: string | null,
//     type?: string | null,
//     message?: string | null,
// };

// export type Announcement = {
//     id?: string | null,
//     type?: string | null,
//     message?: string | null,
// };

// export type User = {
//     id?: string | null,
//     name?: string | null,
// };

// export type Failure = {
//     id?: string | null,
//     site_id?: string | null,
//     site_name?: string | null,
//     device_id?: string | null,
//     device_name?: string | null,
//     signal_name?: SignalName | null,
//     status?: string | null,
//     message?: string | null,
//     start_datetime?: string | null,
//     end_datetime?: string | null,
//     owner?: string | null,
// };

// export type SignalValue = {
//     timestamp?: string | null,
//     value?: number | null,
// }

// export type Signal = {
//     target_id?: string | null,
//     name?: string | null,
//     values?: SignalValue[] | null,
// }
